import { Component, ElementRef, Input, Output, Renderer2, ViewChild, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription, combineLatest, forkJoin, switchMap } from 'rxjs';
import { BeachSite } from 'src/app/models/BeachSite';
import { Council, Region, RegionTypes, getBeachSitesInArea, isSubRegion } from 'src/app/models/SiteGroups';
import { SitesFilter } from 'src/app/models/SitesFilter';
import { ListService } from 'src/app/services/list.service';
import { BeachsitesListService } from '../beachsites-list-service';
import { SitesService } from 'src/app/services/sites.service';
import { uniqWith } from 'lodash';



@Component({
	selector: 'app-filter-results-side-nav',
	templateUrl: './filter-results-side-nav.component.html',
	styleUrls: ['./filter-results-side-nav.component.scss']
})
export class FilterResultsSideNavComponent implements OnInit, OnDestroy, AfterViewInit {
		
	@Output() sitesFilterUpdate = new BehaviorSubject<SitesFilter>(new SitesFilter([], [], [], []));
	//@ViewChild('filterModal') filterModal: ElementRef;	
	@ViewChild('filterScrollArea') filterScrollArea: ElementRef;	
	@ViewChild('submitRef', { read : ElementRef }) submitRef: ElementRef;	
	
	@Input()
	get beachSites() {
		return this.allBeachSites$.getValue();
	}

	set beachSites(value) {
		this.allBeachSites$.next(value);
	}

	public showFiller = false;
	private allBeachSites : BeachSite[] = [];

	//public beachSites$: BehaviorSubject<BeachSite[]>;
	allBeachSites$ = new BehaviorSubject<BeachSite[]>([]);

	private filterPaneOpen: boolean;
	public marginTop: string;
	public height: string;
	private parentTop: Observable<ElementRef>;
	public councilList: Council[] = [];
	public regionList: Region[] = [];
	public siteTypeList: string[] = [];
	public areaMode: string = 'region';
	public searchQuery: string = '';
	public filterActive: boolean = false;
	public selectedSiteTypes: string[] = [];

	private regionsExpanded : number[] = [];
	private councilsExpanded : number[] = [];

	constructor(
		private elRef: ElementRef,
		private sitesService : SitesService, 
		private listService: ListService,
		private formBuilder: FormBuilder,
		private renderer: Renderer2,
		private beachSiteService: BeachsitesListService
	) 
	{
		//this.beachSites$ = new BehaviorSubject<BeachSite[]>([]);
	}

	//council form controls
	public councilFormItems: any = [];
	//region form controls
	public regionFormItems: any = [];
	//site_type form controls
	public siteTypeFormItems: any = [];

	//form group
	public filterForm: FormGroup;

	private regionsSub: Subscription;
	private councilsSub: Subscription;
	private allBeachSitesSub: Subscription;
	private apiRequestsSub : Subscription;
	private listSub: Subscription;
	private regionsCouncilsSub : Subscription;

	private filterParams: SitesFilter = new SitesFilter([], [], [], []);

	async ngOnInit() {
		this.filterForm = this.formBuilder.group({
			keywordFilter: this.formBuilder.control(''),
			regions: this.formBuilder.array([]),
			councils: this.formBuilder.array([]),
			sitesArray : this.formBuilder.array([]),
			site_types: this.formBuilder.array([]),
		});
	
		this.apiRequestsSub = combineLatest([
			this.sitesService.getSitesApi(), 
			this.listService.getRegionList(),
			this.listService.getCouncilList()]).subscribe(
			{
				next : (data) => {
					if(Array.isArray(data) && 3 === data?.length)
					{
						const sites = Array.isArray(data[0]) ? data[0] : [];
						this.allBeachSites = uniqWith(sites, (a : BeachSite, b : BeachSite) => {
							return a.Identifier === b.Identifier;
						});
						this.setSiteFormItems();

						if(Array.isArray(data[1]))
						{
							const tmpRegions = uniqWith(data[1], (regionA : Region, regionB : Region) => {
								return regionA.RegionId === regionB.RegionId;
							});
							const regions = tmpRegions?.filter((a : Region) => {
								return isSubRegion(a);	
							})?.map((region: Region) => {
								const regionBeachSites = getBeachSitesInArea(this.allBeachSites, tmpRegions, region);															
								return { ...region, Sites: regionBeachSites };
							})?.filter((region : Region) => {						
								return 0 < region.Sites?.length;
							})?.sort((a : any, b : any) => a.RegionName?.localeCompare(b.RegionName));	
							this.regionList = regions;
						}
						else
						{
							this.regionList = [];
						}						

						if(Array.isArray(data[1]))
						{
							const tmpCouncils = uniqWith(data[2], (councilA : Council, councilB : Council) => {
								return councilA.CouncilId === councilB.CouncilId;							
							});
							
							const councils = tmpCouncils?.map((council: Council) => {							
								return { ...council, Sites: getBeachSitesInArea(this.allBeachSites, data[1], council, true) };
							}).filter((council : Council) => 0 < council.Sites?.length)?.sort((a : any, b : any) => a.CouncilName?.localeCompare(b.CouncilName));						
							this.councilList = councils;
						}
						else
						{
							this.councilList = [];
						}

						this.setCouncilFormItems();
						this.setRegionFormItems();
					}
				},			
				error : (error : Error) => {
					console.log(error);
				},
				complete : () => {
					
				}
			});

		/*

		this.allBeachSitesSub = this.allBeachSites$.subscribe({
			next : (beachList : BeachSite[]) => {
				if(0 === beachList?.length)
				{
					return;
				}
				this.setSiteFormItems();
				const allRequests = [
					this.listService.getRegionList(),
					this.listService.getCouncilList()
				];
				this.regionsCouncilsSub = combineLatest(allRequests).subscribe({
					next : (data) => {
						if(Array.isArray(data) && 2 === data.length)
						{
							const regions = <Region[]>data[0] || [];
							const councils = <Council[]>data[1] || [];
							this.regionList = [];
							this.councilList = [];
							for(let i = 0; i < regions.length; ++i)
							{
								const region = regions[i];
								if(isSubRegion(region))
								{
									const sites = getBeachSitesInArea(beachList, regions, region, false);									
									if(0 < sites.length)
									{									
										this.regionList.push({...region, Sites : [...sites] });
									}	
								}															
							}

							for(let i = 0; i < councils.length; ++i)
							{
								const council = councils[i];
								const sites = beachList?.filter((site : BeachSite) => site.Council?.toLocaleLowerCase() === council.CouncilName.toLocaleLowerCase());
								if(0 < sites.length)
								{									
									this.councilList.push({ ...council, Sites : [...sites] });
								}
							}							
	
							this.setCouncilFormItems();
							this.setRegionFormItems();						
						}
					},
					error : (ex : Error) => {
	
					},
					complete : () => {
						
					}
				});	
			},
			error : (er : Error) => {

			},
			complete : () => {
				this.allBeachSitesSub && this.allBeachSitesSub?.unsubscribe();
			}
		});
		*/

		this.listSub = this.listService.getSiteTypeList().subscribe({
			next: (data: string[]) => {
				this.siteTypeList = data?.sort((a: string, b: string) =>
					a.localeCompare(b)
				);
				this.setSiteTypeFormItems();
			},
			complete: () => {
				
			}

		});
	}


	ngAfterViewInit(): void {		
		
		const submitRect = this.submitRef?.nativeElement?.getBoundingClientRect();
		const parent = this.filterScrollArea?.nativeElement?.parentElement;
		const parentHeight = this.elRef?.nativeElement?.getBoundingClientRect()?.height - 
			this.elRef?.nativeElement?.children?.[0]?.getBoundingClientRect().height;	
		this.renderer.setStyle(parent, "height", parentHeight + "px");
		const scrollAreaHeight = parentHeight - submitRect.height - 16; // 16x is the gap of flex container
		this.renderer.setStyle(this.filterScrollArea?.nativeElement, "height", scrollAreaHeight + "px");
		this.renderer.setStyle(this.filterScrollArea?.nativeElement, "overflow-y", "auto");		
	}
	
	get councils() {
		return this.filterForm.get('councils') as FormArray;
	}

	get site_types() {
		return this.filterForm.get('site_types') as FormArray;
	}

	get regions() {
		return this.filterForm.get('regions') as FormArray;
	}

	get sitesArray() {
		return this.filterForm.get('sitesArray') as FormArray;
	}

	setCouncilFormItems() {
		let fArr = this.filterForm.get('councils') as FormArray;
		fArr.clear();

		this.councilListFiltered().forEach((e: Council) => {
			let arr = this.filterForm.get('councils') as FormArray;
			let ctrl = this.formBuilder.control('');
			let sitesArr = this.formBuilder.array([]);

			this.sitesFiltered(e.Sites).forEach((site: BeachSite) => {
				sitesArr.push(this.formBuilder.control(''));
			});

			//don't include a council if it has no sites based on the current filter
			if (sitesArr.length > 0) {
				arr.push(
					this.formBuilder.group({ council: ctrl, sites: sitesArr })
				);
			}
		});
	}

	setRegionFormItems() {
		let fArr = this.filterForm.get('regions') as FormArray;
		fArr.clear();

		this.regionListFiltered().forEach((e: Region) => {
			let arr = this.filterForm.get('regions') as FormArray;
			let ctrl = this.formBuilder.control('');
			let sitesArr = this.formBuilder.array([]);

			this.sitesFiltered(e.Sites).forEach((site: BeachSite) => {
				sitesArr.push(this.formBuilder.control(''));
			});

			arr.push(this.formBuilder.group({ region: ctrl, sites: sitesArr }));
		});
	}

	setSiteFormItems() {
		const sitesArr = this.filterForm.get('sitesArray') as FormArray;
		sitesArr.clear();
		this.beachSites?.forEach((site : BeachSite) => {
			sitesArr.push(this.formBuilder.control(false));
		});		
	}

	setSiteTypeFormItems() {
		this.siteTypeList.forEach((e: string) => {
			let arr = this.filterForm.get('site_types') as FormArray;
			arr.push(this.formBuilder.control(''));
		});
	}	

	//using the parent control index and the selected control index get the site object that was selected and add it to the filte params
	onCouncilSiteChange(parentEleIdx: number, elementIdx: number) {
		let councils = this.filterForm.get('councils') as FormArray;
		let currCouncilVal = councils.controls
			.at(parentEleIdx)
			?.get('council')?.value;

		let councilSites = councils.controls
			.at(parentEleIdx)
			?.get('sites') as FormArray;
		let currSiteVal = councilSites.at(elementIdx)?.value;

		//add the site to the filter params if it doesn't exist, remove it if it does
		if (currSiteVal) 
		{
			this.filterParams.sites.push(this.councilList[parentEleIdx].Sites[elementIdx]);
		} 
		else 
		{
			this.filterParams.sites.splice(
				this.filterParams.sites.indexOf(
					this.councilList[parentEleIdx].Sites[elementIdx]),
				1
			);
		}

		//if currCouncilVal is true and the currSiteVal is false we need to uncheck the council
		if (currCouncilVal && !currSiteVal) 
		{
			councils.controls.at(parentEleIdx)?.get('council')?.setValue(false);
		}
	}

	onRegionSiteChange(parentEleIdx: number, elementIdx: number) {
		let regions = this.filterForm.get('regions') as FormArray;
		let currRegionVal = regions.controls
			.at(parentEleIdx)
			?.get('region')?.value;

		let regionSites = regions.controls
			.at(parentEleIdx)
			?.get('sites') as FormArray;
		let currSiteVal = regionSites.at(elementIdx)?.value;

		//add the site to the filter params if it doesn't exist, remove it if it does
		if (currSiteVal) {
			this.filterParams.sites.push(
				this.regionList[parentEleIdx].Sites[elementIdx]
			);
		} else {
			this.filterParams.sites.splice(
				this.filterParams.sites.indexOf(
					this.regionList[parentEleIdx].Sites[elementIdx]
				),
				1
			);
		}

		//if currRegionVal is true and the currSiteVal is false we need to uncheck the region
		if (currRegionVal && !currSiteVal) {
			regions.controls.at(parentEleIdx)?.get('region')?.setValue(false);
		}
	}

	onRegionChange(elementIdx: number) {
		//a region has been checked so we check all the sites in that region
		let regions = this.filterForm.get('regions') as FormArray;
		let currRegionVal = regions.controls
			.at(elementIdx)
			?.get('region')?.value;

		let regionSites = regions.controls
			.at(elementIdx)
			?.get('sites') as FormArray;
		regionSites.controls.forEach((siteControl: any, index: number) => {
			let site: BeachSite = this.regionList[elementIdx].Sites[index];
			let isSiteFiltered: boolean = this.sitesFiltered([site]).length > 0;

			if (isSiteFiltered)
			{
				siteControl.setValue(currRegionVal);

				//add the site to the filter params if it doesn't exist, remove it if it does
				if (
					currRegionVal &&
					this.filterParams.sites.indexOf(site) == -1
				) {
					this.filterParams.sites.push(site);
				} else {
					this.filterParams.sites.splice(
						this.filterParams.sites.indexOf(site),
						1
					);
				}
			} 
			else 
			{
				siteControl.setValue(false);

				//remove the site from the filter params if it is not filtered
				if (this.filterParams.sites.indexOf(site) > -1) {
					this.filterParams.sites.splice(
						this.filterParams.sites.indexOf(site),
						1
					);
				}
			}
		});
	}

	onCouncilChange(elementIdx: number) {
		//a council has been checked so we check all the sites in that council
		let councils = this.filterForm.get('councils') as FormArray;
		let currCouncilVal = councils.controls
			.at(elementIdx)
			?.get('council')?.value;

		let councilSites = councils.controls
			.at(elementIdx)
			?.get('sites') as FormArray;
		councilSites.controls.forEach((siteControl: any, index: number) => {
			let site: BeachSite = this.councilList[elementIdx].Sites[index];
			let isSiteFiltered: boolean = this.sitesFiltered([site]).length > 0;

			if (isSiteFiltered) {
				siteControl.setValue(currCouncilVal);

				//add the site to the filter params if it doesn't exist, remove it if it does
				if (
					currCouncilVal &&
					this.filterParams.sites.indexOf(site) == -1
				) 
				{
					this.filterParams.sites.push(site);
				} 
				else 
				{
					this.filterParams.sites.splice(
						this.filterParams.sites.indexOf(site),
						1
					);
				}
			} 
			else 
			{
				siteControl.setValue(false);

				//remove the site from the filter params if it is not filtered
				if (this.filterParams.sites.indexOf(site) > -1) {
					this.filterParams.sites.splice(
						this.filterParams.sites.indexOf(site),
						1
					);
				}
			}
		});
	}

	onBeachSiteChange(elementIdx : number) 
	{
		const site = this.beachSites?.[elementIdx];
		if(site)
		{
			const index = this.filterParams.sites.findIndex((a : BeachSite) => a === site);
			if(-1 === index)
			{
				this.filterParams.sites.push(site);
			}
			else
			{
				this.filterParams.sites.splice(index, 1);
			}
		}
	}

	onSiteTypeChange(evt: any) {
		let val: string = evt.target.value;
		
		const index = this.filterParams.siteTypes?.indexOf(val);
		
		if(-1 === index)
		{
			this.filterParams.siteTypes.push(val);
		}
		else
		{
			this.filterParams.siteTypes?.splice(index, 1);
		}
		this.selectedSiteTypes = [...this.filterParams.siteTypes];		
	}

	public councilListFiltered() {
		let ret: Council[] = [];

		if (!this.searchQuery && this.selectedSiteTypes.length == 0) 
		{
			ret = this.councilList;
		}			
		else 
		{
			ret = this.councilList.filter((e: Council) => 
			{
				return (
					e.CouncilName.toLocaleLowerCase().includes(
						this.searchQuery.toLocaleLowerCase()
					) || this.sitesFiltered(e.Sites).length > 0
				);
			});
		}
		return ret;
	}

	sitesFiltered(sites: BeachSite[]): BeachSite[] 
	{
		let ret: BeachSite[] = [];

		if (!this.searchQuery && this.selectedSiteTypes.length == 0)
		{
			ret = sites;
		}			
		else 
		{
			ret = sites.filter((e: BeachSite) => 
			{
				if (
					this.searchQuery.length == 0 &&
					this.selectedSiteTypes.length == 0
				) 
				{
					return true;
				} 
				else if (
					this.searchQuery.length == 0 &&
					this.selectedSiteTypes.length > 0
				) 
				{
					return this.selectedSiteTypes.includes(e?.SiteType);
				} 
				else if (
					this.searchQuery.length > 0 &&
					this.selectedSiteTypes.length == 0
				) 
				{
					return e.SiteName.toLocaleLowerCase().includes(
						this.searchQuery.toLocaleLowerCase()
					);
				} 
				else 
				{
					return (
						e.SiteName.toLocaleLowerCase().includes(
							this.searchQuery.toLocaleLowerCase()
						) && this.selectedSiteTypes.includes(e?.SiteType)
					);
				}
			});
		}

		return ret;
	}

	public regionListFiltered() {
		let ret: Region[] = [];

		if (!this.searchQuery && this.selectedSiteTypes.length == 0) {
			ret = this.regionList;
		}
		else 
		{	
			ret = this.regionList
				.filter((e: Region) => {
					return (
						e.RegionName.toLocaleLowerCase().includes(
							this.searchQuery.toLocaleLowerCase()
						) || this.sitesFiltered(e.Sites).length > 0
					);
				})
				.map((z: Region) => {
					return { ...z, Sites: this.sitesFiltered(z.Sites) };
				});
		}
		return ret;
	}

	public areaModeChanged(event: Event) {
		//get event target element value
		var ele = event.target as HTMLInputElement;
		this.areaMode = ele.value;		

		if (this.areaMode == 'council') 
		{			
			this.filterParams.sites = [];
			this.filterForm.get('councils')?.reset();			
		} 
		else if (this.areaMode == 'region') 
		{
			this.filterParams.sites = [];
			this.filterForm.get('regions')?.reset();
		}
		else if(this.areaMode === "beachSites")
		{
			this.filterParams.sites = [];
			this.filterForm.get('beachSites')?.reset();
		}
	}

	//clears the current filter
	public onClearFilterClick(event: Event) {
		event.preventDefault();
		event.stopPropagation();
		this.clearFilter();
	}	

	getSiteTypeLabel(idx: number) {
		return this.siteTypeList[idx];
	}

	getCouncilLabel(idx: number) {
		return this.councilList[idx].CouncilName;
	}

	getRegionLabel(idx: number) {
		return this.regionList[idx].RegionName;
	}

	getRegionSiteNames(siteIdx: number, regionIdx: number) {
		return this.regionList[regionIdx].Sites[siteIdx].SiteName;
	}

	getCouncilSiteNames(siteIdx: number, councilIdx: number) {
		return this.councilList[councilIdx].Sites[siteIdx].SiteName;
	}

	getBeachSiteLabel(siteIdx : number) {
		return this.beachSites?.[siteIdx]?.SiteName ?? "";
	}

	onAreaSearchUpdated(evt: any) 
	{
		if (typeof evt == 'string') 
		{
			this.searchQuery = evt;
		} 
		else 
		{
			this.searchQuery = evt.target.value;
		}
		
	}

	getRegionSites(regionIdx: number)
	{
		let regionArr = this.filterForm.get('regions') as FormArray;
		let sitesArr = regionArr.at(regionIdx).get('sites') as FormArray;

		return sitesArr;
	}

	getCouncilSites(councilIdx: number): FormArray {
		let councilArr = this.filterForm.get('councils') as FormArray;
		let sitesArr = councilArr.at(councilIdx).get('sites') as FormArray;

		return sitesArr;
	}

	onFilterSubmit(evt: Event) {
		evt.preventDefault();
		this.notifyFilterUpdated();
	}

	notifyFilterUpdated = () => {
		this.sitesFilterUpdate.next(this.copyCurrentFilter());
		this.filterActive = !this.filterParams.isEmpty();		
	}


	//used to enable or disable the submit filter button
	isFilterUpdated() {
		return (
			JSON.stringify(this.sitesFilterUpdate.getValue()) !=
			JSON.stringify(this.filterParams)
		);
	}

	//returns a copy of the current filter to pass to the BehaviorSubject
	copyCurrentFilter() {
		return new SitesFilter(
			[...this.filterParams.councils],
			[...this.filterParams.regions],
			[...this.filterParams.sites],
			[...this.selectedSiteTypes]
		);
	}

	//function to check if the area should be shown or not based on control indexes
	showArea(areaIdx: number): boolean {
		if (this.areaMode == 'council') 
		{
			if(this.searchQuery && 
				this.councilList[areaIdx]?.CouncilName.toLowerCase().includes(this.searchQuery?.toLowerCase()))
			{
				return true;	
			}
			
			return this.sitesFiltered(this.councilList[areaIdx].Sites).length > 0;
			
		} 
		else if(this.areaMode === 'region')
		{
			const regionItem = this.regionList[areaIdx];
			if(regionItem?.RegionType?.toLowerCase() === RegionTypes.REGION)
			{
				return false;
			}
			if(this.searchQuery && 
				this.regionList[areaIdx]?.RegionName?.toLowerCase().includes(this.searchQuery?.toLowerCase()))
			{
				return true;
			}
			return this.sitesFiltered(this.regionList[areaIdx].Sites).length > 0;
		}
		else if(this.areaMode === 'beachSites')
		{
			const sites = this.sitesFiltered(this.beachSites);
			const site = this.beachSites?.[areaIdx];
			return -1 < sites.findIndex((a : BeachSite) => a.Identifier === site.Identifier);
		}

		return false;
	}

	//function to check if the site should be shown or not based on control indexes
	showSite(areaIdx: number, siteIdx: number) {
		let site: BeachSite;
		let exists = false;
		if (this.areaMode == 'council') 
		{
			if(this.searchQuery && 
				this.councilList[areaIdx]?.CouncilName.toLowerCase().includes(this.searchQuery?.toLowerCase()))
			{
				exists = true;	
			}
			else
			{
				site = this.councilList[areaIdx].Sites[siteIdx];
				exists = this.sitesFiltered([site]).length > 0;
			}
			
		}
		else if(this.areaMode === 'region')
		{
			if(this.searchQuery && 
				this.regionList[areaIdx]?.RegionName?.toLowerCase().includes(this.searchQuery?.toLowerCase()))
			{
				exists = true;	
			}
			else
			{
				site = this.regionList[areaIdx].Sites[siteIdx];
				exists = this.sitesFiltered([site]).length > 0;
			}			
		}
		else if(this.areaMode === 'beachSites')
		{
			const sites = this.sitesFiltered(this.beachSites);
			const site = this.beachSites?.[siteIdx];
			return -1 < sites.findIndex((a : BeachSite) => a.Identifier === site.Identifier);
		}
		
		return exists;
	}

	//function to check if the list of areas and sites is empty -- NOT IF the filter is empty
	noResultsFound() {
		//get number of Sites from all councils and regions
		const numSites =
			this.councilList.reduce((acc, cur) => {
				return acc + this.sitesFiltered(cur.Sites).length;
			}, 0) +
			this.regionList.reduce((acc, cur) => {
				return acc + this.sitesFiltered(cur.Sites).length;
			}, 0);

		return (
			numSites == 0 &&
			(this.searchQuery.length > 0 || this.selectedSiteTypes.length > 0)
		);
	}

	ngOnDestroy() {
		this.councilsSub && this.councilsSub.unsubscribe();
		this.regionsSub && this.allBeachSitesSub.unsubscribe();
		this.allBeachSitesSub && this.allBeachSitesSub.unsubscribe();
		this.listSub && this.listSub.unsubscribe();
		this.regionsCouncilsSub && this.regionsCouncilsSub?.unsubscribe();
		this.listSub && this.listSub.unsubscribe();
		this.apiRequestsSub && this.apiRequestsSub?.unsubscribe();
	}


	closePanel = (event: any) => {
	}

	
	

	clearFilter() {
		//required to prevent updates to this.filterParams from being passed immediately
		this.filterParams.reset();
		this.sitesFilterUpdate.next(this.copyCurrentFilter());
		this.filterForm.reset({});
		this.searchQuery = '';
		this.onAreaSearchUpdated('' as any);
		this.filterActive = false;
		this.regionsExpanded = [];
		this.councilsExpanded = [];
		this.selectedSiteTypes = [];
		this.notifyFilterUpdated();
	}


	isExpanded(areaType : "Council" | "Region", areaIndex : number) 
	{
		const arr = ("Region" === areaType) ? this.regionsExpanded : 
			("Council" === areaType) ? this.councilsExpanded : [];

		return -1 < arr?.indexOf(areaIndex);
	}


	onExpandButtonClicked = (event : any, areaType : "Council" | "Region", areaIndex : number) => 
	{
		const arr = ("Region" === areaType) ? this.regionsExpanded : 
			("Council" === areaType) ? this.councilsExpanded : [];

		if(Array.isArray(arr))
		{
			const index = arr?.indexOf(areaIndex);
			if(-1 < index)
			{
				arr.splice(index, 1);
			}
			else
			{
				arr.push(areaIndex);
			}
		}		
	}
}


